import { type ParseResult } from "papaparse";

// 会社法人等番号は12桁固定
const CORPORATE_NUMBER_LENGTH = 12;

/**
 * Excelの数値セル読み込みで失われる会社法人等番号の先頭ゼロを補う。
 * 数字のみで12桁未満の場合のみ0埋めし、それ以外はそのまま返す。
 * @param value 会社法人等番号
 * @return 正規化した会社法人等番号
 */
const normalizeCorporateNumber = (value: string): string => {
  if (/^\d+$/.test(value) && value.length < CORPORATE_NUMBER_LENGTH) {
    return value.padStart(CORPORATE_NUMBER_LENGTH, "0");
  }
  return value;
};

/**
 * CSVファイルから重複行を取り除く
 * 重複取り除きルールは「会社法人等番号」が一致している行
 * 重複があった場合、最初の要素のみ残し、後の要素は削除する
 * 「会社法人等番号」が欠落・空の行は重複排除の対象外とし、そのまま残す
 * @param content papaparseのCSVパース結果オブジェクト
 * @return contentから重複行を取り除いたオブジェクト
 */
export const distinctCommercialCsvRows = (
  content: ParseResult<unknown>
): ParseResult<unknown> => {
  const newData: Array<Record<string, string>> = [];

  const getKey = (input: Record<string, string>): string | undefined => {
    const value = input["会社法人等番号"];
    return value ? normalizeCorporateNumber(value) : undefined;
  };

  const seenKeys = new Set<string>();
  content.data.forEach((value) => {
    const record = value as Record<string, string>;
    const key = getKey(record);
    if (key === undefined) {
      newData.push(record);
      return;
    }
    if (seenKeys.has(key)) {
      return;
    }
    seenKeys.add(key);
    newData.push(record);
  });

  return { ...content, data: newData };
};
